import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AjaxDataServiceService } from './ajax-data-service.service';
import { UserModel } from './user-model.model';
import { Observable } from 'rxjs';
import { UrlConfigContainer } from './url-config';
import { UrlConfigService } from '@hrra/core';
import { AdminUserData } from './models/auth.models';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private _user: UserModel;

  public get currentUser() {
    return this.authService.user;
  }

  public get isSignedIn(): boolean {
    return this.currentUser != null;
  }

  // public initUserData(intiData: AdminUserData) {
  //   let user = new UserModel();

  //   this._user = user.fromObject(intiData);
  // }

  // public cleanUserData(){
  //   this._user = null;

  // }

   public loadCurrentUser(): Observable<UserModel> {
    // return this.dataService
    //   .getData(this.urlService.urlConfig.api.data.currentUser.info, {}, UserModel)
    //   .pipe(map((d) => (this._user = d)));
    return this.authService.loadUserInfo().pipe(
      map(d => {
        let user = new UserModel();
        user = user.fromObject(d);
        return user;
      }));
  }

  constructor(
    private authService: AuthService,
    private dataService: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {
    this._user = new UserModel();
  }
}
